<div class="flex flex-col gap-4">
  <!-- 1. Profil public dans l'annuaire -->
  <div
    class="flex items-center justify-between p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs gap-4"
  >
    <div class="flex items-start gap-3 min-w-0">
      <div
        class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 mt-0.5"
        [class.bg-primary-2]="internalSettings().isPublic"
        [class.text-primary-11]="internalSettings().isPublic"
        [class.bg-neutral-2]="!internalSettings().isPublic"
        [class.dark:bg-neutral-3]="!internalSettings().isPublic"
        [class.text-neutral-10]="!internalSettings().isPublic"
      >
        <mat-icon class="!w-5 !h-5 !text-xl">{{
          internalSettings().isPublic ? 'visibility' : 'visibility_off'
        }}</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-bold text-neutral-12">Visibilité publique du profil</span>
        <p class="text-xs text-neutral-10 leading-relaxed mt-0.5">
          Affiche votre profil dans l'annuaire des agents immobiliers d'ETXE et permet aux vendeurs de vous
          solliciter directement.
        </p>
      </div>
    </div>
    <mat-slide-toggle
      [checked]="internalSettings().isPublic"
      (change)="toggleField('isPublic', $event.checked)"
      color="primary"
    ></mat-slide-toggle>
  </div>

  <!-- 2. Mode Vacances / Pause -->
  <div
    class="flex items-center justify-between p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs gap-4"
  >
    <div class="flex items-start gap-3 min-w-0">
      <div
        class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 mt-0.5"
        [class.bg-amber-2]="internalSettings().isVacationMode"
        [class.text-amber-11]="internalSettings().isVacationMode"
        [class.bg-neutral-2]="!internalSettings().isVacationMode"
        [class.dark:bg-neutral-3]="!internalSettings().isVacationMode"
        [class.text-neutral-10]="!internalSettings().isVacationMode"
      >
        <mat-icon class="!w-5 !h-5 !text-xl">beach_access</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-bold text-neutral-12">Mode « Indisponible / En vacances »</span>
        <p class="text-xs text-neutral-10 leading-relaxed mt-0.5">
          Suspend temporairement la réception de nouvelles opportunités de mandats sans déréférencer votre
          profil.
        </p>
      </div>
    </div>
    <mat-slide-toggle
      [checked]="internalSettings().isVacationMode"
      (change)="toggleField('isVacationMode', $event.checked)"
      color="primary"
    ></mat-slide-toggle>
  </div>

  <!-- 3. Indexation par les moteurs de recherche -->
  <div
    class="flex items-center justify-between p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs gap-4"
  >
    <div class="flex items-start gap-3 min-w-0">
      <div
        class="w-10 h-10 rounded-xl bg-neutral-2 dark:bg-neutral-3 text-neutral-11 flex items-center justify-center shrink-0 mt-0.5"
      >
        <mat-icon class="!w-5 !h-5 !text-xl">search</mat-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-bold text-neutral-12">Référencement SEO (Google)</span>
        <p class="text-xs text-neutral-10 leading-relaxed mt-0.5">
          Autorise les moteurs de recherche à référencer votre profil pour attirer des propriétaires cherchant
          un professionnel sur votre secteur.
        </p>
      </div>
    </div>
    <mat-slide-toggle
      [checked]="internalSettings().allowSearchIndexing"
      (change)="toggleField('allowSearchIndexing', $event.checked)"
      color="primary"
    ></mat-slide-toggle>
  </div>
</div>
